// extracted by mini-css-extract-plugin
export default {"label":"ChanceLabel_label","continuousRewards":"ChanceLabel_continuousRewards"};